import {
  alignList,
  langsList,
  searchMode,
  staffNames,
  statusTitles,
} from "../../../data/main";
import { stdObject } from "../../../data/types/stdObject";
import i18n from "../../../locales/i18n";
import {
  customerOptions,
  editAllOptions,
  editDeleteOptions,
  editOptions,
  editOwnAllOptions,
  editVoidOptions,
  filesOptions,
  infoCommOptions,
  infoOptions,
  invTypeOptions,
  itemTypeOptions,
  onlyEditOptions,
  salesReportOptions,
  seePrintSaveOptions,
  selectModifyOptions,
  selectUsersOptions,
  sexesOptions,
  warnAllowOptions,
} from "../../MainStructure/SearchBar/data/searchItemUtils";

export const getInputFormat = (
  code: string,
  {
    t,
    modalData,
    searchList,
    pricesRates,
    formatsList,
    usersList,
    rolsList,
    routesList,
    sucsList,
    brandsList,
    bankAccountsList,
    value,
  }: stdObject,
) => {
  let tempData: stdObject = {};
  switch (code) {
    case "GRU":
      tempData.type = "select";
      tempData.options = [
        { label: t("p.none"), value: "" },
        ...searchList[modalData.type === "pro" ? "cgru" : "vgru"].map(
          (e: stdObject) => {
            return { label: e.NOMGRU, value: e.CODGRU };
          },
        ),
      ];
      break;
    case "PSE":
      tempData.options = [
        { label: t("p.none"), value: "" },
        ...searchList.docInsurances.map((e: stdObject) => {
          return { label: e.NOMPSE, value: e.CODPSE };
        }),
      ];
      tempData.type = "select";
      break;
    case "TAR":
      tempData.type = "select";
      if (!value) {
        tempData.value = pricesRates.length > 0 ? pricesRates[0].CODTAR : 1;
      }
      tempData.options = pricesRates.map((e: stdObject) => {
        return { label: e.NOMTAR, value: e.CODTAR };
      });
      break;
    case "GEN":
      tempData.type = "select";
      tempData.options = [
        { label: "", value: "" },
        ...sexesOptions.map((e: stdObject) => {
          return { ...e, label: t(e.label) };
        }),
      ];
      break;
    case "RUT":
      tempData.type = "select";
      tempData.options = [
        { label: "", value: "" },
        ...routesList.map((e: stdObject) => {
          return { label: e.NOMRUT, value: e.CODRUT };
        }),
      ];
      break;
    case "STO":
      tempData.type = "select";
      tempData.options = invTypeOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "TIP":
      tempData.type = "select";
      tempData.options = itemTypeOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label, { item: t("p.item") }) };
      });
      break;
    case "FOR":
      tempData.type = "select";
      tempData.options = [
        { label: t("p.none"), value: "0" },
        ...formatsList.map((e: stdObject) => {
          return { label: e.NOMFOR, value: e.CODFOR };
        }),
      ];
      break;
    case "NAC":
      tempData.type = "date";
      break;
    case "TIM":
      tempData.type = "info";
      break;
    case "time":
      tempData.type = "time";
      break;
    case "BLO":
    case "MUL":
    case "LOG":
    case "ACTIVO":
    case "RENT":
    case "COMP":
    case "PRON":
    case "ARTN":
    case "PROV":
    case "CLIV":
    case "ARTV":
    case "PROP":
    case "CLIP":
    case "ARTP":
    case "SELVEN":
    case "POS":
    case "WHA":
    case "WEB":
    case "DWN":
    case "TRA":
    case "checkbox":
      tempData.type = "checkbox";
      break;
    case "CLIN":
      tempData.type = "select";
      tempData.options = customerOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "PRO":
    case "CLI":
    case "ART":
      tempData.type = "select";
      tempData.options = editDeleteOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "FTE":
      tempData.type = "select";
      tempData.options = [
        { label: "", value: 0 },
        ...brandsList.map((e: stdObject) => {
          return { label: e.NOMMAR, value: e.CODMAR };
        }),
      ];
      break;
    case "CAL":
      tempData.type = "select";
      tempData.options = editOwnAllOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "ALA":
    case "editOptions":
      tempData.type = "select";
      tempData.options = onlyEditOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "PCO":
      tempData.type = "select";
      tempData.options = editOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "BAJOPCO":
      tempData.type = "select";
      tempData.options = warnAllowOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "AGE":
      tempData.type = "select";
      tempData.options = [
        { value: "", label: "" },
        ...Object.entries(usersList)
          .filter((e: [string, any]) => e[1].COMROL === 0 && e[1].ACTIVO)
          .sort((a: [string, any], b: [string, any]) =>
            a[1].NOMUSU.localeCompare(b[1].NOMUSU),
          )
          .map((e: [string, any]) => {
            return { value: e[0], label: e[1].NOMUSU };
          }),
      ];
      break;
    case "PROD":
    case "CLID":
    case "ARTD":
    case "files":
      tempData.type = "select";
      tempData.options = filesOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "editVoid":
      tempData.type = "select";
      tempData.options = editVoidOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "infoOptions":
      tempData.type = "select";
      tempData.options = infoOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "infoCommOptions":
      tempData.type = "select";
      tempData.options = infoCommOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "seePrintSaveOptions":
      tempData.type = "select";
      tempData.options = seePrintSaveOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "selectUsersOptions":
      tempData.type = "select";
      tempData.options = selectUsersOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "TEC":
      tempData.type = "select";
      tempData.options = editAllOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "COM":
      tempData.type = "select";
      tempData.options = [
        {
          label: "",
          value: "",
        },
        ...staffNames.map((e: string, value: number) => {
          return { label: t(e), value };
        }),
      ];
      break;
    case "modify":
      tempData.type = "select";
      tempData.options = selectModifyOptions.map((e: stdObject) => {
        return { ...e, label: t(e.label) };
      });
      break;
    case "ROL":
      tempData.type = "select";
      tempData.options = [
        {
          label: t("p.none"),
          value: 0,
        },
        ...rolsList.map((e: stdObject) => {
          return {
            label: e.NOMROL,
            value: e.CODROL,
          };
        }),
      ];
      break;
    case "SUC":
    case "branches":
      tempData.type = "select";
      let branchesList = sucsList.map((e: stdObject) => {
        return {
          label: e.NOMSUC,
          value: e.CODSUC,
        };
      });
      if (code === "branches") {
        branchesList.unshift({
          label: t("p.all"),
          value: 0,
        });
      }
      tempData.options = branchesList;
      break;
    case "LANG":
      tempData.type = "select";
      tempData.options = langsList.map((e: stdObject) => {
        return {
          label: t("l." + e.NOMIDI),
          value: e.CODIDI,
        };
      });
      break;
    case "align":
      tempData.type = "select";
      tempData.options = alignList.map((e: stdObject) => {
        return {
          label: t(e.ALINOM),
          value: e.ALICAB,
        };
      });
      break;
    case "statusType":
      tempData.type = "select";
      tempData.options = [
        { label: "", value: "-1" },
        ...searchList.docStatus.map((e: stdObject) => {
          return { label: e.NOMPAG, value: e.CODPAG };
        }),
      ];
      break;
    case "bankAccounts":
      tempData.type = "select";
      tempData.options = [
        { label: t("p.pettyCash"), value: 0 },
        ...bankAccountsList.map((e: stdObject) => {
          return { label: e.NOMCUE, value: e.CODCUE };
        }),
      ];
      break;
    case "color":
    case "integer":
    case "label":
    case "number":
    case "info":
      tempData.type = code;
      break;
    case "issuesType":
      tempData.type = "select";
      tempData.options = [
        { label: t("p.title"), value: -1 },
        ...statusTitles.map((e: stdObject) => {
          return { label: t(e.label), value: e.code };
        }),
      ];
      break;
    case "mode":
      tempData.type = "select";
      tempData.options = searchMode.map((e: string, index: number) => {
        return {
          label: t(e),
          value: index,
        };
      });
      break;
    case "countries":
      const language = i18n.language;
      const countriesList = (
        i18n.store.data[language].translation as Record<string, any>
      ).country;
      tempData.type = "select";
      tempData.options = [
        { label: "", value: "" },
        ...Object.entries(countriesList).map((e) => {
          return { label: e[1], value: e[0] };
        }),
      ];
      break;
    case "salesReport":
      tempData.type = "select";
      tempData.options = salesReportOptions.map((e: stdObject) => {
        return {
          label: t(e.label),
          value: e.value,
        };
      });
      break;
    default:
      tempData.type = "text";
      break;
  }
  return tempData;
};
